import { getAgoraToken, getPlatformInfo } from './api/manage'
import router from './router'
import store from './store'
import cookies from 'vue-cookies'
import { ELocalStorageKey, ERouterName, SystemTitleKey } from './types'
import { CURRENT_CONFIG } from './api/http/config'
import { closeContextMenu, getBuildsList } from './hooks/Cesium'
import { closeCurrentMedia } from './hooks/Cesium/draw-image'
import auth from './plugins/auth'

router.beforeEach((to, from, next) => {
  store.commit('SET_PATH', to.path)
  if (to.path === '/share-video') {
    next()
    return
  }
  if (to.path.indexOf('/big-screen') > -1) {
    next()
    return
  }
  if (to.path === '/' + ERouterName.PILOT) {
    next()
    return
  }
  const Token = cookies.get(ELocalStorageKey.Token)
  const workspace_id = localStorage.getItem(ELocalStorageKey.WorkspaceId)
  let primissions = localStorage.getItem(ELocalStorageKey.permissions)
  if (primissions) { primissions = JSON.parse(primissions) }
  if (Token) {
    closeCurrentMedia()
    closeContextMenu()
    getBuildsList()
    if (Array.isArray(primissions)) {
      store.commit('SET_PERMISSIONS', primissions)
    } else {
      store.commit('SET_PERMISSIONS', [primissions])
    }

    store.commit('SET_SELECT_WAYLINE_INFO', null)
    if (to.path.indexOf('/scenario-plan-detail') > -1 || to.path.indexOf('/wayline-edit-planar') > -1 || to.path.indexOf('/wayline-edit') > -1 || to.path.indexOf('/wayline-edit-strip') > -1 || to.path.indexOf(ERouterName.DATA_UI) > -1) {
      store.commit('SET_HEADER_VISIBLE', false)
    } else {
      store.commit('SET_HEADER_VISIBLE', true)
    }
    if (workspace_id) {
      if (auth.hasPermi(['tsa:airport'])) {
        store.dispatch('getDevices', workspace_id)
      }
      if (auth.hasPermi(['flight:area:fly'])) {
        store.dispatch('getMarkList', workspace_id)
      }
      if (auth.hasPermi(['wayline:tool:fly'])) {
        store.dispatch('getCustumFlyList', workspace_id)
        store.dispatch('getCrawlerGetAll', workspace_id)
      }
      if (auth.hasPermi(['wayline:cloud'])) {
        store.dispatch('getCloundModelList', workspace_id)
      }
    }
    if (store.state.addRoutes.length === 0) {
      store.dispatch('GenerateRoutes').then(accessRoutes => {
        // console.log(accessRoutes, 'accessRoutes路由')
        if (!store.state.hasAddedAsyncRoutes) {
          accessRoutes.forEach((route) => {
            router.addRoute(route)
          })
          store.state.hasAddedAsyncRoutes = true
          next({ ...to, replace: true })
        }
        if (to.path === '/' + ERouterName.PROJECT) {
          next({
            path: '/' + ERouterName.WORKSPACE
          })
          return
        }
        if (to.path !== from.path) {
          next(true)
        } else {
          next(false) // 阻止重复路由跳转
        }
        if (!store.state.location.lat || !store.state.location.lon) {
          getPlatformInfo().then((res) => {
            if (!workspace_id) {
              if (auth.hasPermi(['tsa:airport'])) {
                store.dispatch('getDevices', res.data.workspace_id)
              }
              if (auth.hasPermi(['flight:area:fly'])) {
                store.dispatch('getMarkList', workspace_id)
              }
              if (auth.hasPermi(['wayline:tool:fly'])) {
                store.dispatch('getCustumFlyList', workspace_id)
                store.dispatch('getCrawlerGetAll', workspace_id)
              }
              if (auth.hasPermi(['wayline:cloud'])) {
                store.dispatch('getCloundModelList', workspace_id)
              }
            }
            store.commit('SET_LOCATION', res.data)
            if (to.path === '/' + ERouterName.PROJECT) {
              next({
                path: '/' + ERouterName.WORKSPACE
              })
              return
            }
            if (to.path !== from.path) {
              next(true)
            } else {
              next(false) // 阻止重复路由跳转
            }
          }).catch(() => {
            cookies.remove(ELocalStorageKey.Token)
            next({
              path: '/' + ERouterName.PROJECT
            })
          })
        } else {
          if (to.path === '/' + ERouterName.PROJECT) {
            next({
              path: '/' + ERouterName.WORKSPACE
            })
            return
          }
          if (to.path !== from.path) {
            next(true)
          } else {
            next(false) // 阻止重复路由跳转
          }
        }
      })
    } else {
      if (!store.state.location.lat || !store.state.location.lon) {
        getPlatformInfo().then((res) => {
          if (!workspace_id) {
            if (auth.hasPermi(['tsa:airport'])) {
              store.dispatch('getDevices', res.data.workspace_id)
            }
            if (auth.hasPermi(['flight:area:fly'])) {
              store.dispatch('getMarkList', workspace_id)
            }
            if (auth.hasPermi(['wayline:tool:fly'])) {
              store.dispatch('getCustumFlyList', workspace_id)
              store.dispatch('getCrawlerGetAll', workspace_id)
            }
            if (auth.hasPermi(['wayline:cloud'])) {
              store.dispatch('getCloundModelList', workspace_id)
            }
          }
          store.commit('SET_LOCATION', res.data)
          if (to.path === '/' + ERouterName.PROJECT) {
            next({
              path: '/' + ERouterName.WORKSPACE
            })
            return
          }
          if (to.path !== from.path) {
            next(true)
          } else {
            next(false) // 阻止重复路由跳转
          }
        }).catch(() => {
          cookies.remove(ELocalStorageKey.Token)
          next({
            path: '/' + ERouterName.PROJECT
          })
        })
      } else {
        if (to.path === '/' + ERouterName.PROJECT) {
          next({
            path: '/' + ERouterName.WORKSPACE
          })
          return
        }
        if (to.path !== from.path) {
          next(true)
        } else {
          next(false) // 阻止重复路由跳转
        }
      }
    }
  } else {
    if (to.path === '/' + ERouterName.PROJECT) {
      next()
      return
    }
    next({
      path: '/'
    })
  }
})
